import { formatNumber } from '../utils/helpers';

export const safeStringify = (val) => {
  if (val == null) return '—';
  if (typeof val === 'number') return formatNumber(val);
  if (typeof val === 'string' || typeof val === 'boolean') return String(val);
  if (Array.isArray(val)) return val.map(v => safeStringify(v)).join(', ');
  try {
    return JSON.stringify(val);
  } catch {
    return String(val);
  }
};